import { render, staticRenderFns } from "./HomestayAdd.vue?vue&type=template&id=210e7872"
import script from "./HomestayAdd.vue?vue&type=script&lang=js"
export * from "./HomestayAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports